export const MEMBER_MEMBERHISP_MEMBER_GET_ALL_MEMBER_DIRECTORY_SUCCESS = 'MEMBER_MEMBERHISP_MEMBER_GET_ALL_MEMBER_DIRECTORY_SUCCESS';

export const MEMBER_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_REQUEST = 'MEMBER_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_REQUEST';
export const MEMBER_MEMBERHISP_MEMBER_GET_MEMBER_DIRECTORY_SUCCESS = 'MEMBER_MEMBERHISP_MEMBER_GET_MEMBER_DIRECTORY_SUCCESS';
export const MEMBER_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_FAILURE = 'MEMBER_MEMBERSHIP_MEMBER_GET_MEMBER_DIRECTORY_FAILURE';
